import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ACTION_STATUSES, ACTION_STATUSES_BY_ID, ACTION_SYNC } from "../common/endpoints";
import { ActionStatus } from "../model";
import { HttpService } from "./http.service";

@Injectable()
export class UserActionStatusService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    patchActionStatus(actionStatus: ActionStatus, body: any): Promise<ActionStatus> {
        return firstValueFrom(this.httpService.patch<ActionStatus>(ACTION_STATUSES_BY_ID.replace('{id}', actionStatus.id), body));
    }

    createActionStatus(body: any, historical: boolean): Promise<ActionStatus> {
        const params = new HttpParams().set('historical', historical);
        return firstValueFrom(this.httpService.post<ActionStatus>(ACTION_STATUSES, body, params));
    }

    getActionSynchronizerConfig(thingId: string): Promise<{ workingHours: number }> {
        const params = new HttpParams().set('thingId', thingId);
        return firstValueFrom(this.httpService.get<{ workingHours: number }>(ACTION_SYNC + '/configuration', params));
    }

    resynchronizeActions(thingId: string, thingWorkingHours?: number): Promise<void> {
        let body: any = { thingId: thingId };
        if (thingWorkingHours) {
            body.thingWorkingHours = thingWorkingHours;
        }
        return firstValueFrom(this.httpService.post<void>(ACTION_SYNC, body));
    }
}